import getStore from '../store/configureStore';
import _get from 'lodash/get';

export function getDonateLocaleAPIFormat() {
  const reduxStore = getStore();
  const locale = _get(reduxStore.getState(), 'application.locale', 'en_US');
  return locale.replace('_', '-');
}
